import React, { useState, useEffect, useRef } from 'react';
import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import Close from '@elem/SVGIcon/125wRigidSolarPanel/Close';
import EFVideo from '@/components/UI/EFVideo';
import { getIsPadWidth, getIsMobileWidth2 } from '@elem/utils/devices';
import gtm from '@/utils/gtm';

export const ActionsModal = ({
    title,
    content,
    onBtnClick,
    position = 'bottom',
    activeStatus = 0,
    index = 0,
}: {
    title?: string;
    content: string;
    onBtnClick: any;
    position?: string;
    activeStatus: number;
    index: number;
}) => {
    const handleBtnClick = (index: number) => {
        onBtnClick && onBtnClick(index);
    };

    return (
        <div className={`actions-box actions-box-${index + 1}`} onClick={() => handleBtnClick(index)}>
            {!!title && <p className="tip-title">{title}</p>}

            <div className={`tip-content-box tip-content-box-${position}`}>
                <div className={`close-icon ${activeStatus === index + 1 ? 'close-icon-active' : ''}`}>
                    <Close />
                </div>
                {activeStatus === index + 1 && (
                    <div className={`tip-content ${activeStatus === index + 1 ? 'tip-content-active' : ''} tip-content-${index + 1}`}>
                        <p className="tip-content-item">{content}</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default function BroadCompatibility() {
    const { useLang, useRouter } = useGlobal();
    // const { t } = useLang('solar_panel_125w');
    const { t } = useLang('theProduct.BroadCompatibility');

    const { locale } = useRouter();
    const videoRefPC: any = useRef<HTMLVideoElement>(null);
    const videoRefH5: any = useRef<HTMLVideoElement>(null);
    const isMobile = getIsMobileWidth2();

    const [activeContent, setActiveContent] = useState(0);

    const tipsData = [
        {
            title: t('broad_compatibility_tip_1'),
            content: t.rich('broad_compatibility_content_1', {
                highLight: (text: string) => <span className="highLight-text">{text}</span>,
            }),
        },
        {
            title: t('broad_compatibility_tip_2'),
            content: t('broad_compatibility_content_2'),
        },
        {
            title: t('broad_compatibility_tip_3'),
            content: t.rich('broad_compatibility_content_3', {
                highLight: (text: string) => <span className="highLight-text">{text}</span>,
            }),
        },
    ];

    const handleBtnClick = (index: number) => {
        const gtmValue = localStorage.getItem(`--125w-seamless-open-modal-${index + 1}`) || '';

        if ((!activeContent || activeContent !== index + 1) && !gtmValue) {
            gtm.push({
                event: 'uaEvent',
                event_name: 'product_details',
                tab: t('broad_compatibility_title'),
                button_name: tipsData[index]?.title,
            });
        }
        if (!!activeContent && activeContent === index + 1) {
            setActiveContent(0);
            return;
        }
        setActiveContent(index + 1);
        localStorage.setItem(`--125w-seamless-open-modal-${index + 1}`, `${index + 1}`);
    };

    const initVideoSrcFnPc = async () => {
        try {
            videoRefPC.current.src = 'https://websiteoss.ecoflow.com/upload/video/1731462222343/compatibility_video.mp4';
        } catch (error: any) {
            videoRefPC.current.src = 'https://websiteoss.ecoflow.com/upload/video/1731462222343/compatibility_video.mp4';
        }
    };
    const initVideoSrcFnH5 = async () => {
        try {
            videoRefH5.current.src = 'https://websiteoss.ecoflow.com/upload/video/1731921909265/compatibility_video_h5.mp4';
        } catch (error: any) {
            videoRefH5.current.src = 'https://websiteoss.ecoflow.com/upload/video/1731921909265/compatibility_video_h5.mp4';
        }
    };

    useEffect(() => {
        // const video = videoRef.current;
        // const isPC = window?.innerWidth > 1024;

        if (typeof window !== 'undefined') {
            const initVideo = () => {
                const video: any = !isMobile ? videoRefPC?.current : videoRefH5?.current;

                AniContainer.create({
                    triggerElement: '.broad-compatibility-125w',
                    triggerHook: 1,
                    offset: '20%',
                    duration: '100%',
                    onEnter: () => {
                        video && video?.play();
                    },

                    onLazyLoad: async () => {
                        try {
                            // const isPC = window?.innerWidth > 1024;
                            if (!isMobile) {
                                initVideoSrcFnPc();
                            } else {
                                initVideoSrcFnH5();
                            }
                        } catch (e) {
                            console.error(e);
                        }
                    },
                    lazyHook: 3.5,
                });
            };

            initVideo();
            // window.addEventListener('resize', initVideo);
        }
    }, []);
    return (
        <div className={`broad-compatibility-125w ${css['broad-compatibility-125w']}`}>
            <div className="compatibility-img">
                {/* <EFVideo
                    ref={videoRefPC}
                    className="fullImgs video-pc"
                    width="100%"
                    height="100%"
                    // sources={['https://websiteoss.ecoflow.com/upload/video/1731462222343/compatibility_video.mp4']}
                    autoPlay={false}
                    muted
                    playsInline
                    preload="auto"
                    aria-label="video"
                    loop={false}
                /> */}

                <video
                    ref={videoRefPC}
                    className="fullImgs video-pc"
                    muted
                    // id="dpu-detail-E-video-h5"
                    // src={'/video/effortlessly_1_h5.mp4'}
                    // loop
                    autoPlay={false}
                    // sources={[handleDynamicPath('/video/effortlessly_1_h5.mp4'), handleDynamicPath('/video/effortlessly_1_h5.mp4')]}
                    // autoPlay={false}
                    // loop={false}
                    preload="auto"
                    width="100%"
                    height="100%"
                    playsInline
                />

                <video
                    ref={videoRefH5}
                    className="fullImgs video-h5"
                    muted
                    // id="dpu-detail-E-video-h5"
                    // src={'/video/effortlessly_1_h5.mp4'}
                    // loop
                    autoPlay
                    // sources={[handleDynamicPath('/video/effortlessly_1_h5.mp4'), handleDynamicPath('/video/effortlessly_1_h5.mp4')]}
                    // autoPlay={false}
                    // loop={false}
                    preload="auto"
                    width="100%"
                    height="100%"
                    playsInline
                />
                {/* <EFVideo
                    ref={videoRefH5}
                    className="fullImgs video-h5"
                    width="100%"
                    height="100%"
                    // sources={['https://websiteoss.ecoflow.com/upload/video/1731921909265/compatibility_video_h5.mp4']}
                    autoPlay={false}
                    muted
                    playsInline
                    preload="auto"
                    aria-label="video"
                    loop={false}
                /> */}
            </div>
            <div className="compatibility-box">
                <p className="compatibility-label">{t('broad_compatibility_label')}</p>
                <p className="compatibility-title">{t('broad_compatibility_title')}</p>
                <p className="compatibility-desc">{t('broad_compatibility_desc')}</p>
                <div className="compatibility-tips-box">
                    {tipsData?.map((item: any, index: number) => (
                        <ActionsModal
                            key={index}
                            title={item?.title}
                            content={item?.content}
                            activeStatus={activeContent}
                            onBtnClick={handleBtnClick}
                            index={index}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}
